import { render, staticRenderFns } from "./CapacitacionesListado.vue?vue&type=template&id=10feb69c&scoped=true"
import script from "./CapacitacionesListado.vue?vue&type=script&lang=js"
export * from "./CapacitacionesListado.vue?vue&type=script&lang=js"
import style0 from "./CapacitacionesListado.vue?vue&type=style&index=0&id=10feb69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10feb69c",
  null
  
)

export default component.exports